import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-admin-update-preview',
  templateUrl: './admin-update-preview.component.html',
  styleUrls: ['./admin-update-preview.component.css'],
})
export class AdminUpdatePreviewComponent {
  adminData: any[] = [];
  displayedColumns: string[] = [];

  constructor(
    public dialogRef: MatDialogRef<AdminUpdatePreviewComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.adminData = data.adminData;
    if (this.adminData.length > 0) {
      this.displayedColumns = Object.keys(this.adminData[0]);
    }
  }

  onCloseClick(): void {
    this.dialogRef.close();
  }
}
